import React from 'react';
import styles from '../index.module.scss';

const VideoStreamPreviewItemSkeleton = () => (
  <div className={styles.skeleton}>
    <div className={styles.skeletonPoster} />
    <div className={styles.skeletonTextWrapper}>
      <div className={styles.skeletonTexRow} />
      <div className={styles.skeletonTexRow} />
      <div className={styles.skeletonTexRow} />
    </div>
  </div>
);

export default VideoStreamPreviewItemSkeleton;
